import { useState, useEffect,memo } from "react";
import Tooltip from "@mui/material/Tooltip";
// helpers
import injectVariables from "../../helper/injectVariable";
const FacilityDiscount = memo(({ item,localization}) => {
  const [discountCard, setDiscountCard] = useState([]);

  useEffect(()=>{
    if(item.cards.length){
      setDiscountCard( item.cards.filter(card=>{
        if(card.allowedForDiscounts === true){
          return card
        }
        return false;
      }));
    }
  },[])

  const renderDiscountCards = ()=>{
    if(!discountCard) {
      return
    }
    return discountCard.map(card=>{
      const inputs = { value: card.name };
      const replaced = injectVariables(inputs, localization.onlyWith);
      return (
        <div className="discount-toggle__text" key={card.cardId}>
        <img
          src={card.thumbnailURL}
          alt={card.name}
          loading="lazy"
          width="33"
          height="21"
        />
         {replaced}
      </div>
      )
    })
  }
  const tooltipText = ()=>{
    return (
      // TODO Check DISCOUNTS
      <div className="discount-toggle__count">
        <div className="discount-toggle__list">
          {item.discounts.map((discount) => (
            <span className="discount-toggle__item" key={discount.discountCategoryId}>
              {discount.discountCategoryName}
            </span>
          ))}
        </div>
        {discountCard !== null && renderDiscountCards()}
    </div>
    )
  }
  const tooltipToggle = ()=>{
    return (
      <div className="discount-toggle" data-tip data-for="tooltip">
        <img
          src={"/assets/images/discounts.svg"}
          alt={"percentage icon"}
          loading="lazy"
          width="29"
          height="29"
        />
      </div>
    )
  }
  return (
    <Tooltip
      disableTouchListener
      classes={{tooltip : "tooltip-cont"}}
      title={tooltipText()}
    >
      {tooltipToggle()}
    </Tooltip>
  );
});
export default FacilityDiscount;
